/**
 * Generates SEO-friendly product URLs based on category hierarchy + product slug.
 * Example: /baumarkt/werkzeug/wagenheber-kfz-scherenwagenheber
 */

function generateSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/[äÄ]/g, "ae")
    .replace(/[öÖ]/g, "oe")
    .replace(/[üÜ]/g, "ue")
    .replace(/ß/g, "ss")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

interface ProductForUrl {
  id: string;
  slug?: string | null;
  name?: string;
  category?: {
    slug: string;
    parent?: {
      slug: string;
      parent?: {
        slug: string;
      } | null;
    } | null;
  } | null;
}

export function getProductUrl(product: ProductForUrl): string {
  const slug = product.slug || (product.name ? generateSlug(product.name) : null);
  if (!slug) return `/produkt/${product.id}`;

  const cat = product.category;
  if (!cat?.slug) return `/produkt/${product.id}`;

  // Build category path from hierarchy
  const parts: string[] = [];
  if (cat.parent?.parent?.slug) parts.push(cat.parent.parent.slug);
  if (cat.parent?.slug) parts.push(cat.parent.slug);
  parts.push(cat.slug);
  parts.push(slug);

  return `/${parts.join("/")}`;
}

export function useProductUrl() {
  return { getProductUrl, generateSlug };
}
